import { Grid, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { Stat, SubLine } from '../../../../helperComponents/showPrimitives';
import {
  formatRows,
  isRowsShort,
  formatDuration,
  formatWindow
} from '../../../../../helpers/adsIngestRunsHelpers';
import { formatDateTime } from '../../../../../helpers/adsJobsHelpers';
import { BRIDGE_STATUS_COLORS } from '../../../../../helpers/googleAdsBridgesConstants';

export const RunShowStats = ({ record }) => {
  const finishedText = record.finished_at
    ? [`finished ${formatDateTime(record.finished_at)}`, formatDuration(record.duration_ms)].filter(Boolean).join(' · ')
    : 'not finished';

  return (
    <Grid container spacing={2} sx={{ mb: 2, px: 1 }}>
      <Stat md={4} icon={<AccessTimeIcon fontSize="small" />} caption="Received">
        <Typography variant="h6" fontWeight={600}>{formatDateTime(record.received_at)}</Typography>
        <SubLine>{finishedText}</SubLine>
      </Stat>
      <Stat md={4} icon={<SwapVertIcon fontSize="small" />} caption="Rows">
        <Typography
          variant="h6"
          fontWeight={600}
          sx={isRowsShort(record) ? { color: BRIDGE_STATUS_COLORS.RED } : undefined}
        >
          {formatRows(record)}
        </Typography>
        <SubLine>received / written</SubLine>
      </Stat>
      <Stat md={4} icon={<DateRangeIcon fontSize="small" />} caption="Window">
        <Typography variant="h6" fontWeight={600}>{formatWindow(record.date_from, record.date_to) || '–'}</Typography>
        <SubLine>{record.pages > 1 ? `page ${record.page} of ${record.pages}` : 'single page'}</SubLine>
      </Stat>
    </Grid>
  );
};
